import React from "react";
import styled from "styled-components";

const DropDownList = styled("ul")`
  padding: 0;
  margin: 0;
  padding-left: 1em;
  color: #fffcf2;
  font-size: 14px;
  font-weight: normal;
`;

const ListItem = styled("li")`
  list-style: none;
  margin-bottom: 15px;
  &:hover {
    color: #fd9e46;
    cursor: pointer;
  }
  border-bottom: 2px solid #463434;
  padding-bottom: 20px;
`;

export { DropDownList, ListItem };
